export default function autoFocus(node) {
	node.focus();
}
